<template>
  <v-container class="package-list pa-0" v-if="settings" fluid>
    <div class="package-list-banner">
      <v-container>
        <v-card class="rounded-xl mx-auto"
                max-width="705px"
                max-height="300px">
          <v-img :src="'api/static/'+settings.banner"
                 aspect-ratio="2.35"
                 max-width="705px"
                 max-height="300px"></v-img>
        </v-card>
      </v-container>

      <!--      <div class="white"></div>-->
      <!--      <div class="coloured"></div>-->
    </div>

    <div class="package-list-content-wrapper py-3">
      <v-container class="package-list-content">
        <v-row class="package-list-content-header" no-gutters>
          <v-col v-html="settings.header"></v-col>
        </v-row>

        <v-divider class="package-list-content-divider"></v-divider>

        <v-row class="package-list-content-subheader">
          <v-col v-html="settings.subheader"></v-col>
        </v-row>

        <v-row class="package-list-content-content">
          <v-col v-html="settings.content"></v-col>
        </v-row>

        <v-row class="package-list-content-footer">
          <v-col v-html="settings.footer"></v-col>
        </v-row>

        <v-container>
          <v-row class="package-list-content-packages"
                 justify="center">
            <v-col v-for="packageType in packageTypes"
                   :key="packageType.id"
                   class="text-center"
                   cols="12" md="6" xl="4">
              <v-card class="package-list-content-package ma-2"
                      elevation="0">
                <v-card-text class="px-0 pb-0">
                  <v-container class="d-flex flex-column" style="height: 100%">
                    <v-row class="flex-grow-0">
                      <v-col cols="12" class="package-list-content-package-name">{{ packageType.name }}</v-col>
                      <!--                        <v-col cols="12" class="package-list-content-package-description" v-html="packageType.description"></v-col>-->
                    </v-row>
                    <v-row class="flex-grow-0">
                      <v-col class="package-list-content-package-description my-4">
                        {{packageType.description}}
                      </v-col>
                    </v-row>
                    <v-row class="package-list-content-package-content">
                      <v-col>
                        <v-row v-for="item in JSON.parse(packageType.content)" no-gutters>
                          <v-col cols="12"
                                 class="package-list-content-package-content-item">
                            <label class="my-4 ml-2 text-left">
                              {{ getContentDescription(item) }}
                            </label>
                            <v-spacer></v-spacer>
                            <label class="my-4 mr-2 text-right font-weight-bold">
                              {{ getContentAmount(item) }}
                            </label>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row class="flex-grow-0">
                      <v-col>
                        <v-btn color="primary"
                               class="mt-4"
                               large
                               @click="buy(packageType)">
                          {{ $t('facility.buy') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-container>
    </div>

    <BGModal :shown="paymentModalShown"
             height="60vh">
      <template #content>
        <v-container fluid v-if="buyingPackage" class="package-preview">
          <v-form class="package-preview-form"
                  v-model="isFormValid">
            <v-row>
              <v-col cols="12" md="6">
                <v-row class="package-preview-form-title">
                  <v-col>{{ $t('package.preview') }}</v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field readonly
                                  hide-details
                                  :label="$t('package.name')"
                                  :value="buyingPackage.type.name"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field readonly
                                  hide-details
                                  :label="$t('package.price')"
                                  prefix="HKD"
                                  :value="buyingPackage.price"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-checkbox light
                                v-model="accepted"
                                @click.stop="showTnc"
                                validate-on-blur>
                      <template v-slot:label>
                        <div @click.stop="showTnc">{{ $t('booking_preview.accept_tnc1') }} {{ $t('booking_preview.accept_tnc2') }}</div>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6">
                <v-row class="package-preview-form-title">
                  <b-col>{{ $t('booking_preview.time_left') }} {{ timeLeft }}</b-col>
                </v-row>
                <v-row class="preview-warning-label">
                  <v-col>{{ $t('booking_preview.preview_warning') }}</v-col>
                </v-row>
                <v-row class="package-preview-form-title">
                  <v-col class="pb-0">{{ $t('booking.payment_method') }}</v-col>
                </v-row>
                <v-row>
                  <v-col class="pt-0">
                    <v-container>
                      <v-row>
                        <v-col cols="7"
                               :class="['package-preview-payment-method', {'active': paymentMethod === 'cyber_source'}]"
                               @click="paymentMethod = 'cyber_source'">
                          <v-img :src="require('../../../assets/logo-credit-cards.png')"></v-img>
                        </v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="4"
                               :class="['package-preview-payment-method', {'active': paymentMethod === 'union_pay'}]"
                               @click="paymentMethod = 'union_pay'">
                          <v-img :src="require('../../../assets/logo-union-pay.png')"></v-img>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
                <v-row v-if="paymentMethod === 'cyber_source'">
                  <v-col>
                    <v-radio-group v-model="selectedPaymentToken">
                      <v-radio v-for="paymentToken in paymentTokens"
                               :key="paymentToken.id"
                               :value="paymentToken.id">
                        <template #label>
                          <v-img :src="cardTypeLogo[paymentToken.card_type]"
                                 :max-width="40"
                                 :max-height="30"
                                 class="mr-4"></v-img>
                          {{ `${paymentToken.card_number} (${paymentToken.card_expiry_date})` }}
                        </template>
                      </v-radio>
                      <v-radio :value="false">
                        <template #label>
                          <v-icon class="mr-4">fas fa-plus-square</v-icon>
                          {{ $t('booking_preview.add_payment_token') }}
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </template>
      <template #footer>
        <v-row no-gutters>
          <v-btn @click="paymentModalShown = false"
                 class="mr-3"
                 depressed
                 large>
            {{ $t('cancel') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary"
                 depressed
                 large
                 @click="pay"
                 :disabled="!isFormValid">
            {{ $t('header.pay') }}
            <v-icon right>fas fa-check</v-icon>
          </v-btn>
        </v-row>
      </template>
    </BGModal>

    <v-dialog v-model="tncDialogShown" scrollable>
      <v-card light>
        <v-card-title class="tnc-title title-font">{{ tnc.title }}</v-card-title>

        <v-card-text @scroll="onScroll" v-html="tnc.content" class="text-left"></v-card-text>

        <v-card-actions class="tnc-actions">
          <v-spacer></v-spacer>
          <span v-if="!tncScrolledToBottom">{{ $t('booking.tnc_scroll_to_bottom') }}</span>
          <v-spacer></v-spacer>

          <v-btn text
                 :disabled="!tncScrolledToBottom"
                 class="tnc-action title-font"
                 @click="setAcceptTnc(true)">
            {{ $t('register.agree') }}
          </v-btn>

          <v-btn text
                 :disabled="!tncScrolledToBottom"
                 class="tnc-action title-font"
                 color="rgb(142, 118, 91)"
                 @click="setAcceptTnc(false)">
            {{ $t('register.disagree') }}
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {computed, onMounted, ref, watch} from '@vue/composition-api';
import {BOOKING_RECORD_STATUS} from "@/constants";
import {DateTime} from "luxon";
import BGModal from "@/components/BGModal";

export default {
  name: 'PackageList',
  components: {BGModal},
  setup(props, {root}) {
    const step = ref(0);

    onMounted(() => {
      getItemTypes();
      getPackages();
      getTNC();
    })

    const settings = ref(null);
    const packageTypes = ref([]);
    const getPackages = function () {
      root.$callAPI('aafb/package/types/', {}, (response) => {
        settings.value = response.body.settings;
        packageTypes.value = response.body.package_types;
      })
    };

    const itemTypes = ref([]);
    const itemTypeNameMap = computed(() => {
      let map = {};

      itemTypes.value.forEach((t) => {
        map[t.id] = t.name;
      })

      return map;
    })
    const getItemTypes = function () {
      root.$callAPI('aafb/facility_types/', {}, function (response) {
        itemTypes.value = response.body.item_types;
      });
    }

    const getContentDescription = function (item) {
      if (item.type === 'point') {
        return root.$t('my_account.points');
      } else if (item.type === 'coupon') {
        return `${itemTypeNameMap.value[item.coupon.item_type_id]} ${root.$t('my_account.coupon')}`
      }
    };
    const getContentAmount = function (item) {
      if (item.type === 'point') {
        return item.point;
      } else if (item.type === 'coupon') {
        return `HKD ${item.coupon.amount} X ${item.coupon.count}`
      }
    };

    const buy = function (packageType) {
      if (root.$store.state.user.id) {
        root.$callAPI('aafb/package/create/', {
          type_id: packageType.id,
        }, (response) => {
          buyingPackage.value = response.body.package;
          getPaymentTokens();
          paymentModalShown.value = true;
          countDownInterval.value = setInterval(calculateTimeLeft, 1000);
        })
      } else {
        root.$showAlertMessage(root.$t('login_msg'), () => {
          root.$router.push({name: 'login', query: {after: root.$route.path}})
        })
      }
    }

    // Count Down
    const countDownInterval = ref(null);
    const timeLeft = ref('10:00');
    const calculateTimeLeft = function () {
      let valid_until = null;
      if (buyingPackage.value.status === BOOKING_RECORD_STATUS.PENDING) {
        valid_until = DateTime.fromISO(buyingPackage.value.create_at).plus({minutes: 10});
      }

      if (valid_until === null || DateTime.local() > valid_until) {
        clearInterval(countDownInterval.value)
        root.$showAlertMessage(
            root.$t('package.order_expired_msg'),
            () => {
              root.$router.reload();
            }
        )
      }

      let diff = valid_until.diff(DateTime.local(), ['minutes', 'seconds']);

      timeLeft.value = Math.floor(diff.minutes).toString().padStart(2, '0') + ":" + Math.floor(diff.seconds).toString().padStart(2, '0');
    }

    // Payment
    const paymentModalShown = ref(false);
    const buyingPackage = ref(null);
    const isFormValid = ref(false);

    const paymentMethod = ref(null);
    const selectedPaymentToken = ref(false);
    const paymentTokens = ref([]);
    const cardTypeLogo = ref({
      '001': require('@/assets/visa.jpg'),
      '002': require('@/assets/mastercard.png'),
      '007': require('@/assets/jcb.gif'),
    });
    const getPaymentTokens = function () {
      root.$callAPI('payment/cyber_source/payment_tokens/', {}, (response) => {
        paymentTokens.value = response.body.payment_tokens;

        if (paymentTokens.value.length > 0) {
          selectedPaymentToken.value = paymentTokens.value[0].id;
        }
      })
    }

    // TNC
    const tnc = ref('');
    const tncDialogShown = ref(false);
    const tncScrolledToBottom = ref(false);
    const accepted = ref(false);
    const getTNC = function () {
      root.$callAPI('hkiarace/tnc/', {}, function (response) {
        tnc.value = response.body;
      });
    };
    const showTnc = function (e) {
      e.preventDefault();

      if (!accepted.value) {
        tncDialogShown.value = true;
      } else {
        accepted.value = false;
      }
    };
    const onScroll = function ({target: {scrollTop, clientHeight, scrollHeight}}) {
      if (scrollTop + clientHeight >= (scrollHeight - 10)) {
        tncScrolledToBottom.value = true
      }
    }
    const setAcceptTnc = function (accept) {
      tncDialogShown.value = false;
      accepted.value = accept;
    }

    const pay = function () {
      if (confirm(root.$t('booking_preview.redirect_warning'))) {
        root.$callAPI('aafb/package/init_payment/', {
          package_id: buyingPackage.value.id,
          payment_method: paymentMethod.value,
          payment_token_id: selectedPaymentToken.value,
        }, function (response) {
          postForm(response.body.url, response.body.params);
        });
      }
    }
    const postForm = function (path, params, method = 'post') {
      const form = document.createElement('form');
      form.method = method;
      form.action = path;

      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          const hiddenField = document.createElement('input');
          hiddenField.type = 'hidden';
          hiddenField.name = key;
          hiddenField.value = params[key];

          form.appendChild(hiddenField);
        }
      }

      document.body.appendChild(form);
      form.submit();
      root.$startLoading();
    }

    return {
      step,

      settings,
      packageTypes,

      getContentDescription,
      getContentAmount,

      buy,

      timeLeft,
      paymentModalShown,
      buyingPackage,
      isFormValid,

      paymentMethod,
      selectedPaymentToken,
      paymentTokens,
      cardTypeLogo,

      tnc,
      tncDialogShown,
      tncScrolledToBottom,
      accepted,
      showTnc,
      onScroll,
      setAcceptTnc,

      pay,
    }
  },
}
</script>

<style lang="less">
.package-list {
  height: 100%;
  display: flex;
  flex-direction: column;
  font-family: 'Montserrat', Roboto, "PingFang TC", "Heiti TC", "\5FAE\8EDF\6B63\9ED1\9AD4", "Microsoft JhengHei", "sans-serif" !important;

  .package-list-banner {
    width: 100%;
    //height: 300px;

    background: repeating-linear-gradient(0deg, #dcd8d2 0, #dcd8d2 50%, white 50%, white 100%) !important;
  }

  .package-list-content-wrapper {
    background-color: #dcd8d2;

    .package-list-content {
      max-width: 1200px;

      .package-list-content-header {
        color: #9b836b !important;
        font-size: 150%;
      }

      .package-list-content-divider {
        border-color: white;
      }

      .package-list-content-subheader {
        color: #9b836b !important;
      }

      .package-list-content-content {
        color: #959493 !important;
        font-size: 80%;
      }

      .package-list-content-footer {
        color: #9b836b !important;
      }

      .package-list-content-packages {
        .package-list-content-package {
          background-color: #f5f5f5;
          height: 100%;

          .v-card__text {
            height: 100%
          }

          .package-list-content-package-name {
            text-decoration: underline;
            color: #9b836b !important;
            font-size: 110%;
          }

          .package-list-content-package-description {
            color: #9b836b !important;
            font-size: 150%;
            font-weight: bold;
          }

          .package-list-content-package-content {
            background-color: #efeeed;

            .package-list-content-package-content-item {
              color: #9b836b !important;
              display: flex;
              //border-bottom: solid 1px #dcd8d2;

              &:first-child {
                //border-top: solid 1px #dcd8d2;
              }
            }
          }
        }
      }
    }
  }
}

.package-preview {
  background-color: white;

  .package-preview-form {
    max-width: 1024px;
    margin: auto;

    .v-label {
      color: #8E765B;
    }

    .v-input--is-readonly > .v-input__control > .v-input__slot:before {
      display: none;
    }

    .v-input--is-readonly > .v-input__control > .v-input__slot:after {
      display: none;
    }

    .package-preview-form-title {
      font-size: 1.5rem;
    }

    .preview-warning-label {
      font-size: .8rem;
    }

    .package-preview-payment-method {
      border: 2px solid rgba(0, 0, 0, 0.2);
      cursor: pointer;


      &:hover, &.active {
        border-color: #8E765B;
      }
    }
  }
}
</style>
